const EventType = {
  clickContinue: "clickContinue",
  clickSubmit: "clickSubmit",
  clickConfirm: "clickConfirm"
}

export default EventType
